"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getExportQuotesStatus = void 0;

var _actions = require("./actions");

var _getRequestStatus = _interopRequireDefault(require("settings-ui-sdk/RequestStatuses/getRequestStatus"));

var getExportQuotesStatus = (0, _getRequestStatus.default)(_actions.QuotesActionTypes.EXPORT_QUOTES);
exports.getExportQuotesStatus = getExportQuotesStatus;